var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEditBtnWhite7B3084Bc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_2197",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52078",
    "data-name": "Group 52078",
    transform: "translate(-974 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52033",
    "data-name": "Group 52033",
    transform: "translate(986 260.194)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -10.19)",
    filter: "url(#Ellipse_2197)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2197-2",
    "data-name": "Ellipse 2197",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_116_14",
    "data-name": "Component 116 \\u2013 14",
    transform: "translate(8 7.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45690",
    "data-name": "Group 45690",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63236",
    "data-name": "Path 63236",
    d: "M5,19V16.414a1,1,0,0,1,.293-.707l10-10a1,1,0,0,1,1.414,0l1.586,1.586a1,1,0,0,1,0,1.414l-10,10A1,1,0,0,1,7.586,19Z",
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5072",
    "data-name": "Line 5072",
    x2: 2.969,
    y2: 2.969,
    transform: "translate(13.875 7.188)",
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19776",
    "data-name": "Rectangle 19776",
    width: 20,
    height: 20,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditBtnWhite7B3084Bc);
export default __webpack_public_path__ + "static/media/ico-edit-btn-white.7b3084bc.a1335397913791bba4ecd79d870346c6.svg";
export { ForwardRef as ReactComponent };